export const connectorMixin =
  ({ connectorClasses }) =>
  (superclass) =>
    class ConnectorMixinClass extends superclass {
      #connectorClasses = connectorClasses;

      static get observedAttributes() {
        return [...(superclass.observedAttributes || []), 'connector-template'];
      }

      get connectorClasses() {
        return this.#connectorClasses;
      }

      set connectorClasses(value) {
        this.#connectorClasses = value;
      }

      get connectorTemplate() {
        return this.getAttribute('connector-template');
      }

      initializeConnector() {
        const template = this.connectorTemplate;

        if (!this.connectorClasses[template]) {
          return;
        }
        const ConnectorClass = this.connectorClasses[template];
        this.connector = new ConnectorClass(this.getAttribute.bind(this));
      }

      async fetchConnectorResults(query) {
        if (!this.connector) {
          // eslint-disable-next-line no-console
          console.error(
            `No connector initialized for the field with template: ${this.connectorTemplate}`,
          );
          return { results: [] };
        }

        const { results, error } = await this.connector.fetch(query);
        if (error) {
          return { results: [], error };
        }
        return {
          results: results.map(({ label, value }) => ({
            label,
            value,
          })),
        };
      }

      init() {
        super.init?.();
        this.initializeConnector();
      }

      attributeChangedCallback(attrName, oldValue, newValue) {
        super.attributeChangedCallback?.(attrName, oldValue, newValue);

        if (oldValue !== newValue) {
          if (attrName === 'connector-template') {
            this.initializeConnector();
          }
        }
      }
    };
